<mat-tab-group>
    <mat-tab label="Niveles de Inventario">

            <div class="d-flex flex-column-reverse flex-sm-row align-items-center pt-3 px-2 px-sm-4" style="width: 100%;">
                <div class="col-12">
                    <app-date [value]="today" class="p-0" appearance="fill" (dateSelected)="chosenDate($event)"></app-date>
                </div>
            </div>

            <ng-container *ngTemplateOutlet="comboWarehouseTemplate; context: {type: 'inventory'}">
            </ng-container>


        <div class="container">
            <data-table style="width: 100%" title="" [columns]="columnI" [url]='urlTableInventoryLevel' [configuration]="configurationI"
                [reloadTable]="reloadTableI" [params]="paramsInventoryLevel"
                (internalData)="dataItems($event)"></data-table>
        </div>

    </mat-tab>

    <mat-tab label="Pedidos y Reabastecimiento">

        <div class="d-flex flex-column flex-sm-row justify-content-around pt-3 px-2 px-sm-4" style="width: 100%;">
            <combos appearance="fill" class="col-12 " style="width: 100%;"
                [configuration]="combosConfigProvider" [reloadCombo]="reloadComboProvider" [filter]="true"
                [additionalData]="additionalData" (changeOption)="changeValueProvider($event)">
            </combos>
        </div>

        <ng-container *ngTemplateOutlet="comboWarehouseTemplate; context: {type: 'purchaseOrder'}">
        </ng-container>

        <div class="container">
            <data-table title="" [columns]="columnsPO" [url]='urlTableInventoryPendingPurchaseOrders'
                [configuration]="configurationPO" [reloadTable]="reloadTablePO"
                [params]="paramsInventoryPendingPurchaseOrders"></data-table>
        </div>

    </mat-tab>

    <mat-tab label="Cumplimiento Anual de Pedidos">
        <div class="col d-flex flex-column flex-sm-row align-items-center mt-4">
            <app-date [value]="today"   class="col-12" appearance="fill" type="year" (dateSelected)="chosenDateAverageTimeOrder($event)"></app-date>
        </div>
        <div class="chart-wrapper container-graph">
            <canvas baseChart id="averageTimeOrder" class="Grafic" [datasets]="chartDataAverageTimeOrder"
                [labels]="chartLabelsAverageTimeOrder" [plugins]="[]" [legend]="true"
                [type]="chartTypeAverageTimeOrder" [options]="barChartOptions">
            </canvas>
        </div>

    </mat-tab>

    <mat-tab label="Entradas Anuales">

        <div class="col d-flex flex-column flex-sm-row align-items-center pt-3 px-2 px-sm-4 mt-2">
            <app-date [value]="today"  class="col-12" appearance="fill" type="year" (dateSelected)="chosenDateInputs($event)"></app-date>
        </div>

        <ng-container *ngTemplateOutlet="comboWarehouseTemplate; context: {type: 'inputs'}">
        </ng-container>

        <div class="chart-wrapper container-graph">
            <canvas baseChart id="numberAnnualInputs" class="Grafic" [datasets]="chartDataNumberAnnualInputs"
                [labels]="chartLabelsNumberAnnualInputs" [plugins]="[]" [legend]="true"
                [type]="chartTypeNumberAnnualInputs" [options]="barChartOptions">
            </canvas>
        </div>

    </mat-tab>

    <mat-tab label="Salidas Anuales">

        <div class="col d-flex flex-column flex-sm-row align-items-center pt-3 px-2 px-sm-4 mt-2">
            <app-date [value]="today"  class="col-12" appearance="fill" type="year" (dateSelected)="chosenDateOutputs($event)"></app-date>
        </div>

        <ng-container *ngTemplateOutlet="comboWarehouseTemplate; context: {type: 'outputs'}">
        </ng-container>

        <div class="chart-wrapper container-graph">
            <canvas baseChart id="numberAnnualOutputs" class="Grafic" [datasets]="chartDataNumberAnnualOutputs"
                [labels]="chartLabelsNumberAnnualOutputs" [plugins]="[]" [legend]="true"
                [type]="chartTypeNumberAnnualOutputs" [options]="barChartOptions">
            </canvas>
        </div>

    </mat-tab>

    <mat-tab label="Estado Ordenes de Compra Anuales">
        <div class="col d-flex flex-column flex-sm-row align-items-center mt-4">
            <app-date [value]="today"  class="col-12" appearance="fill" type="year" (dateSelected)="chosenDatePurchaseOrderStatus($event)"></app-date>
        </div>
        <div class="chart-wrapper container-graph">
            <canvas baseChart id="OrderStatusAnnualOutputs" class="Grafic"
                [datasets]="chartDataPurchaseOrderStatus"
                [labels]="chartLabelsPurchaseOrderStatus"
                [plugins]="[]"
                [legend]="true"
                [type]="chartTypePurchaseOrderStatus"
                [options]="barChartOptions">
            </canvas>
        </div>
    </mat-tab>
</mat-tab-group>


  <ng-template #comboWarehouseTemplate let-type="type">
    <div class="d-flex flex-column flex-sm-row justify-content-around p-2 p-sm-4" style="width: 100%;">
      <combos appearance="fill" class="col-12 " style="width: 100%;"
        [dataCombos]="warehouses"
        [configuration]="combosConfigWarehouse"
        [reloadCombo]="reloadComboWarehouse"
        [filter]="true"
        (changeOption)="changeValueWarehouse($event, type)"
        [disabled]="!warehouses || warehouses.length === 1">
      </combos>
    </div>
  </ng-template>
